<script setup lang="ts">
import type { PropType } from 'vue';
import { getContainer } from '@dandelion/core';
import type { CaseListColumn } from '@dandelion/core';
import type TranslationService from '@dandelion/core/src/services/TranslationService';
import { Contexts } from '@dandelion/core';
import { NamedBindings } from '@dandelion/core';

const props = defineProps({
  caseListColumns: {
    type: Array as PropType<Array<CaseListColumn>>,
    required: false,
    default: () => new Array<CaseListColumn>(),
  },
  context: {
    type: String as PropType<string>,
    required: false,
    default: Contexts.DEFAULT,
  },
});

const ts = getContainer(props.context).get(NamedBindings.TranslationService) as TranslationService;
</script>

<template>
  <thead class="case-list-head">
    <tr>
      <th
        v-for="c in caseListColumns"
        :key="c.getHeading()"
        :class="[`${c.getHeading().toLocaleLowerCase()}-head-cell`, 'head-cell']"
        v-html="ts.t(c.getHeading())"
      />
      <th class="actions-head-cell head-cell" />
    </tr>
  </thead>
</template>
